import Chip from "@vahak/core-ui/dist/components/Chip";
import Styles from "./VerifiedPill.module.scss";

interface VerifiedPillProps {
    onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
    isTapNgoVerified?: boolean;
    isSpotLoad?: boolean;
}

const VerifiedPill = ({ onClick, isTapNgoVerified, isSpotLoad }: VerifiedPillProps) => {
    let _text = "";
    if (isTapNgoVerified || isSpotLoad) {
        _text = "Vahak Assured";
    }
    return !!_text ? (
        <Chip
            color="orange"
            onClick={onClick}
            filled
            fillColor="transparent"
            size="small"
            radius={"16px"}
            padded={false}
        >
            {_text}
        </Chip>
    ) : (
        <div className={Styles.verified} onClick={onClick}>
            <div className={Styles.verifiedText}>Verified</div>
        </div>
    );
};

export default VerifiedPill;
